var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "#020025",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76367 15.2367L15.3628 8.63672",
    stroke: "#020025",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 8.53906C9.06528 8.53906 9.12972 8.55861 9.18454 8.59524C9.23936 8.63187 9.28208 8.68393 9.30731 8.74483C9.33254 8.80574 9.33914 8.87277 9.32628 8.93743C9.31342 9.00209 9.28167 9.06148 9.23505 9.1081C9.18843 9.15472 9.12904 9.18646 9.06438 9.19932C8.99972 9.21219 8.9327 9.20559 8.87179 9.18036C8.81088 9.15513 8.75882 9.1124 8.72219 9.05759C8.68557 9.00277 8.66602 8.93832 8.66602 8.8724C8.66602 8.78399 8.70113 8.69921 8.76365 8.63669C8.82616 8.57418 8.91094 8.53906 8.99935 8.53906",
    stroke: "#020025",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1283 14.668C15.1942 14.668 15.2586 14.6875 15.3134 14.7241C15.3683 14.7608 15.411 14.8128 15.4362 14.8737C15.4614 14.9346 15.468 15.0017 15.4552 15.0663C15.4423 15.131 15.4106 15.1904 15.364 15.237C15.3173 15.2836 15.2579 15.3154 15.1933 15.3282C15.1286 15.3411 15.0616 15.3345 15.0007 15.3093C14.9398 15.284 14.8877 15.2413 14.8511 15.1865C14.8145 15.1317 14.7949 15.0672 14.7949 15.0013C14.7949 14.9129 14.83 14.8281 14.8926 14.7656C14.9551 14.7031 15.0398 14.668 15.1283 14.668",
    stroke: "#020025",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.bacdf998.svg";
export { ForwardRef as ReactComponent };